import {ComponentBase} from '../../core/entities/component-base';
import {OnDestroy, OnInit} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';

export class NowComponentBase extends ComponentBase implements OnInit, OnDestroy {

  private _date: BehaviorSubject<number> =  new BehaviorSubject<number>(Date.now());
  private _dateTimeOutRef: any;
  public readonly now: Observable<number> = this._date.asObservable();

  constructor() {
    super();
  }

  public getInterval(): number {
    return 15000;
  }

  ngOnInit(): void {
    const me = this;
    const dateTimeOut = function(){
      me._date.next(Date.now());
      me._dateTimeOutRef = setTimeout( () => dateTimeOut(), me.getInterval()
      );
    };
    dateTimeOut();
  }

  ngOnDestroy(): void {
    clearTimeout(this._dateTimeOutRef);
  }

}




// WEBPACK FOOTER //
// ./src/app/shared/base/NowComponentBase.ts